import React from "react";
import * as XLSX from "xlsx";

function ExcelUpload({ onNumbersExtracted, buttonClassName = "", buttonLabel = "Upload Excel File" }) {
  // Function to convert Excel serial date to "dd-mm-yyyy" format
  const excelSerialToDate = (serial) => {
    // Excel dates start from January 1, 1900
    const excelEpoch = new Date(1899, 11, 30); // Dec 30, 1899 (to account for Excel's leap year bug)
    const daysInMs = serial * 24 * 60 * 60 * 1000;
    const date = new Date(excelEpoch.getTime() + daysInMs);

    // Format to dd-mm-yyyy
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, {
          type: "array",
          dateNF: "dd-mm-yyyy",
        }); // Add dateNF option
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

        // Process the data
        const extractedData = json
          .slice(1) // Remove header
          .map((row) => {
            return row
              .map((cell, index) => {
                // Check if this is the DOB column (assuming it's index 2)
                if (index === 2 && typeof cell === "number" && cell > 10000) {
                  // Likely an Excel serial date
                  return excelSerialToDate(cell);
                }
                return cell;
              })
              .filter(Boolean); // Remove empty cells
          })
          .filter((row) => row.length > 0 && row[0] && row[1]); // Remove invalid rows

        onNumbersExtracted(extractedData);
      };
      reader.readAsArrayBuffer(file);
    }
  };

  return (
    <div className="h-fit w-full text-[1rem] sm:w-auto">
      <label
        className={`cursor-pointer rounded-xl border border-indigo-500/30 bg-gradient-to-r from-indigo-600 to-violet-600 px-3 py-2 text-xs font-medium text-white transition-all hover:opacity-95 ${buttonClassName}`}
      >
        {buttonLabel}
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileChange}
          className="hidden"
        />
      </label>
    </div>
  );
}

export default ExcelUpload;

// import React from "react";
// import * as XLSX from "xlsx";

// function ExcelUpload({ onNumbersExtracted }) {
//   // Function to convert Excel serial date to "dd-mm-yyyy" format
//   const excelSerialToDate = (serial) => {
//     // Excel dates start from January 1, 1900
//     const excelEpoch = new Date(1899, 11, 30); // Dec 30, 1899 (to account for Excel's leap year bug)
//     const daysInMs = serial * 24 * 60 * 60 * 1000;
//     const date = new Date(excelEpoch.getTime() + daysInMs);

//     // Format to dd-mm-yyyy
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
//     const year = date.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const data = new Uint8Array(event.target.result);
//         const workbook = XLSX.read(data, { type: "array", dateNF: "dd-mm-yyyy" }); // Add dateNF option
//         const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
//         const json = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

//         // Process the data
//         const extractedData = json
//           .slice(1) // Remove header
//           .map((row) => {
//             return row.map((cell, index) => {
//               // Check if this is the DOB column (assuming it's index 2)
//               if (index === 2 && typeof cell === "number" && cell > 10000) {
//                 // Likely an Excel serial date
//                 return excelSerialToDate(cell);
//               }
//               return cell;
//             }).filter(Boolean); // Remove empty cells
//           })
//           .filter((row) => row.length > 0 && row[0] && row[1]); // Remove invalid rows

//         onNumbersExtracted(extractedData);
//       };
//       reader.readAsArrayBuffer(file);
//     }
//   };

//   return (
//     <div className="mt-2 px-2 sm:px-4">
//       <h4 className="text-sm font-semibold mb-2 text-center sm:text-left">
//         Upload Excel File
//       </h4>
//       <div className="flex flex-col sm:flex-row items-center sm:space-x-2">
//         <input
//           type="file"
//           accept=".xlsx, .xls"
//           onChange={handleFileChange}
//           className="border border-gray-300 rounded-md p-1 text-sm w-full sm:w-auto"
//         />
//       </div>
//     </div>
//   );
// }

// export default ExcelUpload;
